import * as S from './state';

export const BudgetList = [25, 50, 100, 150, 200, 250, 300, 400, 500, 800, 1000, 1500, 2000];

export const NameTransferFees: S.ConditionKeyValue<S.NameTransferFeekey>[] = [
    {
        key: '',
        value: '指定なし',
    },
    {
        key: 'under_50',
        value: '50万未満',
    },
    {
        key: 'between_50_100',
        value: '50〜100万未満',
    },
    {
        key: 'between_100_200',
        value: '100〜200万未満',
    },
    {
        key: 'over_200',
        value: '200万以上',
    },
];

export const Distances: S.ConditionKeyValue<S.HighwayDistanceKey>[] = [
    {
        key: '10',
        value: '10km',
    },
    {
        key: '20',
        value: '20km',
    },
    {
        key: '30',
        value: '30km',
    },
];

export const AnnualFees: S.ConditionKeyValue<S.AnnualFeeKey>[] = [
    {
        key: '',
        value: '指定なし',
    },
    {
        key: 'under_3',
        value: '3万円未満',
    },
    {
        key: 'between_3_5',
        value: '3〜5万円未満',
    },
    {
        key: 'between_5_7',
        value: '5〜7万円未満',
    },
    {
        key: 'over_7',
        value: '7万円以上',
    },
];

export const Playstyles: S.ConditionKeyValue<S.PlaystyleKey>[] = [
    {
        key: 'walkable',
        value: '歩きラウンド可能',
    },
    {
        key: 'cart_usable',
        value: '乗用カート利用可能',
    },
    {
        key: 'caddy_selectable',
        value: 'キャディ有無選択可能',
    },
];

export const PracticePlaces: S.ConditionKeyValue<S.PracticePlaceKey>[] = [
    {
        key: 'has_chipping_green_for_practice',
        value: 'アプローチ練習場',
    },
    {
        key: 'has_bunker_for_practice',
        value: 'バンカー練習場',
    },
];

export const MemberCounts: S.ConditionKeyValue<S.MemberCountKey>[] = [
    {
        key: '',
        value: '指定なし',
    },
    {
        key: 'under_1000',
        value: '1000名以下',
    },
    {
        key: 'between_1001_1500',
        value: '1001〜1500名',
    },
    {
        key: 'between_1500_2000',
        value: '1500〜2000名',
    },
    {
        key: 'over_2001',
        value: '2001名以上',
    },
];

export const AdmissionConditions: S.ConditionKeyValue<S.AdmissionConditionKey>[] = [
    {
        key: 'is_handicap_unnecessary',
        value: 'ハンディ不要',
    },
    {
        key: 'is_interview_unnecessary',
        value: '面接なし',
    },
    {
        key: 'is_enrollment_in_others_unnecessary',
        value: '他コース在籍不要',
    },
    {
        key: 'is_no_age_limit',
        value: '年齢制限なし',
    },
    {
        key: 'female_enrollable',
        value: '女性入会可能',
    },
    {
        key: 'is_accompany_impossible',
        value: '同伴プレイなし',
    },
];

export const Others: S.ConditionKeyValue<S.OtherKey>[] = [
    {
        key: 'has_professional_tournament',
        value: 'プロトーナメント開催実績あり',
    },
    {
        // serverでは相当する値は持たないがこのkeyをboolでなげる
        key: 'is_course_length_more_than_6800',
        value: '6800ヤード以上',
    },
    {
        key: 'has_club_bus',
        value: 'クラブバスあり',
    },
    {
        key: 'is_held_competition_over_twenty_times',
        value: '競技会が多い（年20回以上）',
    },
    {
        key: 'has_registration_family_system',
        value: '家族登録制度あり',
    },
    {
        key: 'recruitment',
        value: '新規会員募集中',
    },
];
